import { queryOptions, useQuery } from '@tanstack/react-query'
import { getWorkspaces } from '../lib/api'

export function workspacesQueryOptions() {
  return queryOptions({
    queryKey: ['workspaces'] as const,
    queryFn: getWorkspaces,
  })
}

export function useWorkspaces() {
  return useQuery(workspacesQueryOptions())
}
